'use client';

import { useEffect, useRef, useState, type IframeHTMLAttributes } from 'react';

// Iframe montato solo quando il contenitore si avvicina al viewport.
// Il loading="lazy" nativo di Chrome carica gli iframe già a ~1250-2500px di
// distanza, quindi su mobile una mappa sotto la piega parte subito.
export default function LazyIframe({ className, ...props }: IframeHTMLAttributes<HTMLIFrameElement>) {
  const ref = useRef<HTMLDivElement>(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { rootMargin: '200px' }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  return (
    <div ref={ref} className={className}>
      {isVisible && <iframe {...props} className="w-full h-full" />}
    </div>
  );
}
